import { useEffect, useState } from 'react'

import style from '../../../styles/Weather/weather_location'
import EditWeatherLocation from './EditWeatherLocation'

const WeatherLocation = ({ locationTitle, locationChanged }) => {
  const [currentLocation, setCurrentLocation] = useState(false)

  useEffect(() => {
    if (locationTitle) {
      setCurrentLocation(locationTitle)
    }
  }, [locationTitle])

  return (
    <>
      <h1>
        Weather in {currentLocation}{' '}
        <EditWeatherLocation
          locationChanged={location => {
            setCurrentLocation(location.name)
            locationChanged(location)
          }}
        />
      </h1>
      <style jsx>{style}</style>
    </>
  )
}

export default WeatherLocation
